/**
 * The one time zone this app's calendar logic runs in.
 *
 * The fleet filter contract (§6.3) rules out the browser's zone: "this month" must mean the same
 * thing to every staff member, whatever their laptop is set to, and to CI, which runs in UTC.
 * Florida filing periods are civil months in Eastern time.
 */
export const PINNED_TIME_ZONE = 'America/New_York';

function parts(now: Date): { year: number; month: number; day: number } {
  const fmt = new Intl.DateTimeFormat('en-US', {
    timeZone: PINNED_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
  let year = 0;
  let month = 0;
  let day = 0;
  for (const p of fmt.formatToParts(now)) {
    if (p.type === 'year') year = Number(p.value);
    if (p.type === 'month') month = Number(p.value);
    if (p.type === 'day') day = Number(p.value);
  }
  return { year, month, day };
}

/** The civil date (month 1–12) containing `now` in the pinned zone. */
export function datePartsInPinnedZone(now: Date = new Date()): { year: number; month: number; day: number } {
  return parts(now);
}

/** "YYYY-MM" for the civil month containing `now` in the pinned zone. */
export function yearMonthInPinnedZone(now: Date = new Date()): string {
  const { year, month } = parts(now);
  return `${year}-${String(month).padStart(2, '0')}`;
}

/** The civil year containing `now` in the pinned zone. */
export function yearInPinnedZone(now: Date = new Date()): number {
  return parts(now).year;
}
